import { DocumentCirculationComponent } from './documentcirculation/documentcirculation';
import { VidangeComponent } from './vidange/vidange';
import { NavParams } from 'ionic-angular';
import { Carburant } from './carburant/carburant';
import { Component } from '@angular/core';
import { Dashbord } from './dashbord/dashbord';
import { ViewController } from 'ionic-angular/navigation/view-controller';
import { Events } from 'ionic-angular/util/events';


@Component({
    templateUrl: 'gest-park.html'
  })
  export class GestionPark {
    tab1Root = Carburant;
    tab2Root= Dashbord;
    tab3Root=VidangeComponent;
    tab4Root=DocumentCirculationComponent;
    data:any;
    constructor(public navParams:NavParams,public viewCtrl:ViewController,public events:Events) {
        this.data = navParams.get('data')
        events.subscribe('Dismiss',x => {
          // user and time are the same arguments passed in `events.publish(user, time)`
          viewCtrl.dismiss(x);
        });
    }
    
  }


// WEBPACK FOOTER //
// ./src/pages/gestion-park/gest-park.ts